import url from 'url-parse';

const isAbsoluteUrl = src => /http[s]?:\/\//.test(src);

const getConfig = () => {
  const metaEnabled = document.querySelector('meta[name="hstatic-enabled"]');
  const metaHstaticDomain = document.querySelector('meta[name="hstatic-domain"]');
  const metaHstaticDomainConfig = document.querySelector('meta[name="hstatic-domain-config"]');
  const metaBaseUrl = document.querySelector('meta[name="base-url"]');

  // Do not use hstatic if any configuration misses
  if (!metaEnabled || !metaHstaticDomain || !metaHstaticDomainConfig || !metaBaseUrl) {
    return false;
  }

  const enabled = (metaEnabled.content === 'true');
  const hstaticDomain = metaHstaticDomain.content;

  // Decode domain configuration
  const domainConfig = metaHstaticDomainConfig.content.split(',').map((item) => {
    const decodedItem = item.split('=');

    return { domainShortHand: decodedItem[ 0 ], domain: decodedItem[ 1 ] };
  });

  const baseUrl = metaBaseUrl.content;

  // Do not use hstatic if any configuration misses
  if (!enabled || !baseUrl || !domainConfig || !hstaticDomain) {
    return false;
  }

  return {
    enabled,
    baseUrl,
    domainConfig,
    hstaticDomain,
  };
};

export default (src) => {
  const config = getConfig();
  if (!config) {
    return src;
  }

  const { baseUrl, domainConfig, hstaticDomain } = config;

  let parsedUrl = src;
  let domain = url(baseUrl);

  if (isAbsoluteUrl(src)) {
    domain = url(parsedUrl);
    parsedUrl = domain.pathname;
  }

  // Trim leading slash from string
  parsedUrl = parsedUrl.replace(/^\//g, '');

  const domainConfigObject = domainConfig.find(option => option.domain === domain.host);

  if (!domainConfigObject) {
    return src;
  }

  return `https://${domainConfigObject.domainShortHand}.${hstaticDomain}/${parsedUrl}`;
};
